<template>
  <v-card v-if="isChartDataValid" class="pa-4 rounded-xl elevation-2 mt-4" style="background-color: #fbeee6;">
    <!-- <h4 class="text-h6 mb-4">PNL History</h4> -->
    <LineChart :data="props.data" :options="chartOptions" />
  </v-card>
</template>

<script setup>
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  TimeScale // ⬅️ Required for time-based x-axis
} from 'chart.js'

import 'chartjs-adapter-date-fns' // ⬅️ Adapter for time parsing

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  TimeScale // ⬅️ Must be registered
)

import { computed, watch } from 'vue'
import { Line as LineChart } from 'vue-chartjs'

// ✅ Register chart components
ChartJS.register(Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, PointElement)

// ✅ Define props (expecting `data`)
const props = defineProps({
  data: {
    type: Object,
    default: () => ({ labels: [], datasets: [] })
  }
})

// ✅ Check if data is valid
const isChartDataValid = computed(() =>
  props.data && Array.isArray(props.data.labels) && props.data.labels.length > 0 && Array.isArray(props.data.datasets) && props.data.datasets.length > 0
)

// ✅ Options
import 'chartjs-adapter-date-fns'

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      type: 'time', // ⬅️ enables date support
      time: {
        unit: 'day',
        tooltipFormat: 'dd-MM-yyyy'
      },
      title: {
        display: true,
        text: 'Date'
      }
    },
    y: {
      title: {
        display: true,
        text: 'Value'
      }
    }
  },
  plugins: {
    legend: { position: 'top' },
    title: { display: false }
  }
}


// ✅ Watch for debug
watch(() => props.data, (val) => {
  console.log('📊 ChartComponent received:', val)
})
</script>




<style scoped>
.v-card {
  height: 350px;
}
</style>
